import { z } from 'zod'

export const OfficeTimeEntrySchema = z.object({
  id: z.number(),
  employeeUserId: z.number().catch(0),
  employeeName: z.string().nullable().optional().catch(null),
  startedAt: z.string(),
  endedAt: z.string().nullable().optional().catch(null),
  workDate: z.string().catch(''),
  workedMinutes: z.number().nullable().optional().catch(null),
  autoClosed: z.boolean().optional().catch(false),
})

export type OfficeTimeEntry = z.infer<typeof OfficeTimeEntrySchema>

export const OfficeClockStatusSchema = z.object({
  enabled: z.boolean().catch(false),
  eligible: z.boolean().catch(false),
  open: OfficeTimeEntrySchema.nullable().optional().catch(null),
})

export type OfficeClockStatus = z.infer<typeof OfficeClockStatusSchema>

export const parseOfficeTimeList = (data: unknown): OfficeTimeEntry[] => {
  if (!Array.isArray(data)) return []
  return data.flatMap((item) => {
    const parsed = OfficeTimeEntrySchema.safeParse(item)
    return parsed.success ? [parsed.data] : []
  })
}

export interface OfficeClockRequest {
  lat?: number
  lng?: number
}

export interface ListOfficeTimeParams {
  from: string
  to: string
  employeeUserId?: number
}

export interface CreateOfficeTimeRequest {
  employeeUserId: number
  startedAt: string
  endedAt: string
}

export interface UpdateOfficeTimeRequest {
  startedAt: string
  endedAt: string
}

export const OFFICE_AUTO_CLOSED_NOTE = 'Closed automatically — check the end time'
